import React from 'react';
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
  ATHENEUM_ROUTE_PREFIX,
  ATHENEUM_PROGRAMS_MODULE_ROUTE,
  ATHENEUM_COURSES_MODULE_ROUTE,
  // ATHENEUM_QUERY_MODULE_ROUTE,
  // ATHENEUM_USER_MODULE_ROUTE,
  ATHENEUM_ORDERS_MODULE_ROUTE,
  // ATHENEUM_WISHLIST_MODULE_ROUTE,
  ATHENEUM_CART_MODULE_ROUTE,
  ATHENEUM_OFFER_MODULE_ROUTE,
  ATHENEUM_USER_MODULE_ROUTE,
  ATHENEUM_CERTIFICATION_MODULE_ROUTE,
  // ATHENEUM_OFFER_MODULE_ROUTE,
} from '../../routes/routes';
const linkStyle = {
  height: 64,
  paddingLeft: 16,
  paddingRight: 16,
  marginTop: 8,
  marginBottom: 8,
  borderRadius: 4,
};

const useStyles = makeStyles((theme) => ({
  overAll: { height: 510, paddingLeft: 5, paddingRight: 5 }, // 438
  linkStyle: {
    ...linkStyle,
  },
  linkStyleActive: {
    ...linkStyle,
    backgroundColor: theme.palette.buzzActiveLinkBackground,
  },
  textStyle: {
    textDecoration: 'none',
  },
}));

const isActiveRoute = (routeName, pathName) => {
  if (
    pathName === ATHENEUM_ROUTE_PREFIX.slice(0, -1) &&
    routeName === ATHENEUM_PROGRAMS_MODULE_ROUTE
  )
    return true;
  else if (pathName !== ATHENEUM_ROUTE_PREFIX.slice(0, -1)) {
    return pathName.includes(routeName);
  }
};

const SideNavBar = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const theme = useTheme();

  const paths = [
    {
      name: 'Programs',
      link: ATHENEUM_PROGRAMS_MODULE_ROUTE,
    },
    {
      name: 'Courses',
      link: ATHENEUM_COURSES_MODULE_ROUTE,
    },
    {
      name: 'Offer',
      link: ATHENEUM_OFFER_MODULE_ROUTE,
    },
    {
      name: 'Register Users',
      link: ATHENEUM_USER_MODULE_ROUTE,
    },
    {
      name: 'Orders',
      link: ATHENEUM_ORDERS_MODULE_ROUTE,
    },
    // {
    //   name: 'Wishlist',
    //   link: ATHENEUM_WISHLIST_MODULE_ROUTE,
    // },
    {
      name: 'Cart',
      link: ATHENEUM_CART_MODULE_ROUTE,
    },
    {
      name: 'Certification',
      link: ATHENEUM_CERTIFICATION_MODULE_ROUTE,
    },
  ];

  return (
    <Box
      flex={2}
      mr={3}
      border={1}
      borderColor={theme.palette.buzzBorder}
      borderRadius={4}
      className={classes.overAll}>
      {paths.map((path) => {
        const isActive = isActiveRoute(path.link, pathname);
        return (
          <Link
            key={path.name}
            to={path.link}
            color="inherit"
            className={classes.textStyle}>
            <Box
              className={isActive ? classes.linkStyleActive : classes.linkStyle}
              display="flex"
              alignItems="center">
              <Box flexGrow={1}>
                <Typography color="textPrimary" component="div">
                  <Box fontWeight={isActive ? 'fontWeightMedium' : ''}>
                    {path.name}
                  </Box>
                </Typography>
              </Box>
              {isActive && <ChevronRightIcon color="primary" />}
            </Box>
          </Link>
        );
      })}
    </Box>
  );
};

export default SideNavBar;
